import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusquedaPersonasComponent } from './busqueda-personas.component';
import {DatosNoEncontradosModule} from '../datos-no-encontrados/datos-no-encontrados.module';
import {SpinnerModule} from '../spinner/spinner.module';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {BotonFiltroModule} from '../boton-filtro/boton-filtro.module';
import {NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import {ExtendedModule, FlexModule} from '@angular/flex-layout';
import {MatTableModule} from '@angular/material/table';
import {GrillaPersonasComponent} from './grilla-personas/grilla-personas.component';



@NgModule({
  declarations: [BusquedaPersonasComponent, GrillaPersonasComponent],
  imports: [
    CommonModule,
    DatosNoEncontradosModule,
    SpinnerModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    BotonFiltroModule,
    NgbAlertModule,
    FlexModule,
    MatTableModule,
    ExtendedModule
  ],
  exports: [BusquedaPersonasComponent, GrillaPersonasComponent],
  bootstrap: [GrillaPersonasComponent]
})
export class BusquedaPersonasModule { }
